import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { queryClient } from '@src/core/api/query-client';

import { QUERY_KEYS } from '@shared/constants/query-keys';
import type { TLocale } from '@shared/types/locale';

export type TLocaleQuery = {
  code?: string;
  name?: string;
  o?: '-id' | 'id';
  page_number?: string | number;
  page_size?: string | number;
};

export const getAllLocales = async (options?: {
  query?: TLocaleQuery;
}): Promise<TLocale[]> => {
  return request({
    url: `locales/all/`,
    params: options?.query,
  });
};

export const useGetAllLocales = (
  query?: TLocaleQuery,
  options?: Partial<UseQueryOptions<TLocale[]>>
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.getLocales, query],
    queryFn: async () => await getAllLocales({ query }),
    staleTime: Infinity, // cache for the entire session
    ...options,
  });
};

export const getCachedLocales = (
  query?: TLocaleQuery
): TLocale[] | undefined => {
  return queryClient.getQueryData<TLocale[]>([QUERY_KEYS.getLocales, query]);
};

export const getAllLocalesQueryOptions = (query?: TLocaleQuery) => ({
  queryKey: [QUERY_KEYS.getLocales, query],
  queryFn: async () => await getAllLocales({ query }),
  staleTime: Infinity,
});
